import Modal from "app/components/Modal";
import React from "react";

interface Props {
  onClose: () => void;
  onSave: () => void;
  children: React.ReactNode; // ✅ allows JSX, text, etc.
  title: string;
  cancelText?: string;
  submitText?: string;
  loading: boolean;
}

const ConfirmationModalWrapper: React.FC<Props> = ({
  onSave,
  onClose,
  title,
  cancelText = "Cancel",
  submitText = "Archive",
  children,
  loading,
}) => {
  return (
    <Modal
      title={title}
      onClose={() => onClose()}
      submitText={submitText}
      cancelButtonText={cancelText}
      onSubmit={onSave}
      submitLoading={loading}
      modalClassName="flex flex-col items-center p-0 gap-[0] absolute w-[400px] left-[50%] top-[50%] transform -translate-x-1/2 -translate-y-1/2 bg-white border border-[#E9ECF2] rounded-lg"
    >
      {children}
    </Modal>
  );
};

export default ConfirmationModalWrapper;
